import { Skeleton } from '@mui/material';
import { PaymentMethodMiniCard } from '../styles';
import { SwitchCardLabel, SwitchCardSwitch } from './SwitchCard.styles';

export const SwitchCard = ({ label, onChange, checked, loading }) => {
  if (loading) return <SwitchCardSkeleton />;
  return (
    <PaymentMethodMiniCard>
      <SwitchCardLabel>{label}</SwitchCardLabel>
      <SwitchCardSwitch onChange={onChange} checked={checked} />
    </PaymentMethodMiniCard>
  );
};

const SwitchCardSkeleton = () => {
  return (
    <PaymentMethodMiniCard>
      <Skeleton width={120} height={22} />
      <Skeleton width={50} height={38} />
    </PaymentMethodMiniCard>
  );
};
